// EXTERNAL
import { useHistory } from "react-router-dom";
import { useState } from "react";

// CSS
import "./FrontPage.css"

// COMPONENTS
import LabelledInputBox from "../components/LabelledInputBox.js"
import BrandingPanel from "../components/BrandingPanel.js";
import SubmitButton from "../components/SubmitButton.js"
import InfoBox from "../components/InfoBox.js"

// SERVICES
import fetchWithToken from "../services/fetchWithToken.js";

/** 
 * This component renders the password set page.
 * 
 * @returns {ReactElement} A React element that renders the password set page. 
 */
export default function PasswordSetPage({}) {
  const history = useHistory();
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");

  const validatePassword = () => {
    if (password.length < 8) {
        setPopupMessage("Password must be at least 8 characters.");
        setShowPopup(true);
    } else if (/^\d+$/.test(password)) {
        setPopupMessage("Password cannot be entirely numeric.");
        setShowPopup(true);
    } else if (password !== repassword && repassword.length > 0) {
        setPopupMessage("Password fields must match.");
        setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  };

  const handleSetPassword = async (e) => {
    const userData = document.forms["Log In"].elements;

    const response = await fetchWithToken(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/users/set_password/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
          current_password: userData["Current Password"].value,
          new_password: userData["New Password"].value,
          re_new_password: userData["Confirm New Password"].value,
        }),
    })

    if (response.status == 204) {
      history.push("/login?reason=changed-password")
    } else {
      const errorData = await response.json();
      setPopupMessage(Object.values(errorData)[0].join("\n"));
      setShowPopup(true);
    }
  }

  return (
    <div className="front-page-body">
      <BrandingPanel></BrandingPanel>
      <div className="front-page-content">
        <InfoBox boxStyle="default" isVisible={showPopup} onClose={() => setShowPopup(false)}>{popupMessage}</InfoBox>
        <form className="front-page-form" name="Log In" action={handleSetPassword}>
          <h2>Change Password</h2>
          <div className="front-page-vertical-labelled-input-boxes">
            <LabelledInputBox label="Current Password" type="password" placeholder="Current Password" required={true} onChange={(e) => setPassword(e.target.value)} onBlur={validatePassword}></LabelledInputBox>
            <LabelledInputBox label="New Password" type="password" placeholder="New Password" required={true} onChange={(e) => setRepassword(e.target.value)} onBlur={validatePassword}></LabelledInputBox>
            <LabelledInputBox label="Confirm New Password" type="password" placeholder="Confirm New Password" required={true}></LabelledInputBox>
          </div>
          <div className="front-page-button-group">
            <SubmitButton buttonStyle="secondary">Submit</SubmitButton>
          </div>
        </form>
        <div className="copyright">{`© Korotu Technology ${process.env.REACT_APP_COPYRIGHT_YEAR}`}</div>
      </div>
    </div>
  )
}